module.exports = __webpack_public_path__ + "img/dead_end_icon.f3e90acb.png";